<div class="growerProgramBudgetDialog margin-r15">
  <div class="row dialogHeader">
    <h2>Select A Budget</h2>
  </div>
  <div class="row">
    <div class="col-12 margin-t10">
      <div class="productTableOuter">
        <div class="tableContainer prodTableContainer">
          <table mat-table [dataSource]="budgetDataSource" multiTemplateDataRows class="matTables productTable">
            <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="column === 'rowNumber'"></ng-container>
                <ng-container *ngIf="column === 'budgetName'">Budget Name</ng-container>
                <ng-container *ngIf="column === 'programName'">Program Name</ng-container>
                <ng-container *ngIf="column === 'budgetOwner'">Budget Owner</ng-container>
              </th>
              <td mat-cell *matCellDef="let element;let i = dataIndex" (click)="selectRow(element)" [ngClass]="{'highlightRow': selectedRowId == element.id}">
                <ng-container *ngIf="column === 'rowNumber'" class="text-left">
                  <p>{{ i + 1 }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'budgetName'" class="text-left">
                  <p>{{ element.value }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'programName'" class="text-left">
                  <p>{{ element.programName }}</p>
                </ng-container>
                <ng-container *ngIf="column === 'budgetOwner'" class="text-left">
                  <p>{{ element.budgetOwner }}</p>
                </ng-container>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row add-order-sec margin-l0 margin-r0">
  <div class="col-12 padding-l25">
    <div class="row">
      <div class="col-6 padding-l25">
        <button mat-raised-button class="btns w180" [disabled]="!selectedElement" color="primary" (click)="selectBudget()">Select Budget</button>
      </div>
      <div class="col-6 text-right m-auto padding-r30">
        <div>BUDGET COUNT: {{budgetDataSource?.length}} </div>
      </div>
    </div>
  </div>
</div>
